module.exports = __webpack_public_path__ + "img/Anek.002be11e.jpg";